import CockpitNotificationPagingResultModelBase from '../_generated/modelBases/cockpit-notification-paging-result-model-base';

export default class CockpitNotificationPagingResultModel extends CockpitNotificationPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
